import React from 'react';
import { useCurrentAgentLogo } from '../../hooks/useCurrentAgentLogo';
import { Breadcrumb, BreadcrumbItem } from '../Breadcrumb';
import './FormHeader.css';

interface FormHeaderProps {
  breadcrumbItems: BreadcrumbItem[];
  children?: React.ReactNode;
  className?: string;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  breadcrumbItems,
  children,
  className = '',
}) => {
  const { logo } = useCurrentAgentLogo();

  return (
    <header className={`form-header ${className}`.trim()}>
      <div className="header-logo-with-breadcrumb">
        <div className="header-logo-wrapper">
          <img src={logo} alt="Logo" className="header-logo" />
        </div>
        <Breadcrumb items={breadcrumbItems} inline />
      </div>
      {children}
    </header>
  );
};

export default FormHeader;
